// +----------------------------------------------------------------------
// | 404
// +----------------------------------------------------------------------
import { Link } from 'react-router-dom';
import './NotFound.less';

export default function NotFound() {
  return (
    <div className="page center notfound">
      <div className="notfound-emoji">🤔</div>
      <h1 className="notfound-title">这里好像没什么好纠结的</h1>
      <p className="muted">页面没找到，可能是地址打错了。</p>
      <Link to="/" className="btn btn-primary btn-sm notfound-btn">
        回首页想想
      </Link>
    </div>
  );
}
